import React from 'react';
import {View} from 'react-native';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Markdown from 'react-native-markdown-package';

import Text from '/component/base/Text';

import {styles} from './Point.style';

// Define the types for the props
interface PointProps {
  item: string;
}

export const Point: React.FC<PointProps> = ({item = ''}) => (
  <View style={styles.container}>
    <Text style={styles.dot}>{'\u2022'}</Text>
    <Markdown
      styles={{
        text: styles.text,
        view: styles.view,
      }}>
      {item}
    </Markdown>
  </View>
);
